import { AbstractCase } from "../../types/Entities/AbstractCase";
import { getButton, getContent, getPercentage } from "../litigationCase/statusBoxSteps";
import { getProductData } from "../productService";
import { ExtraContent } from "../litigationCase/StatusBox/ExtraContent";

export const getStatusBoxConfigEmploymentContract = (employmentContractCase: AbstractCase) => {
  const content = getContent(employmentContractCase);

  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(employmentContractCase),
    productName: getProductData(employmentContractCase.name, "label"),
    percentage: getPercentage(employmentContractCase),
    extraContent: <ExtraContent litigationCase={employmentContractCase} />,
  };
};
